import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CalGuardService } from '@cvx/cal-angular';
export const routes: any[] = [
    {
        path: 'home',
        redirectTo: '',
        pathMatch: 'full'
    },
    {
        path: '',
        title: 'Supplier Spend Visibility',
        icon: 'home',
        isNav: true,
        canActivate: [CalGuardService],
        roles:[],
        loadComponent: () => import('src/components/home/home.component').then(m => m.HomeComponent)
    },
    {
        path: 'user-guide',
        title: 'User-Guide',
        icon: "information.png",
        isNav: true,
        canActivate: [CalGuardService],
        roles: [],
        loadComponent: () => import('src/components/user-guide/user-guide.component').then(m => m.UserGuideComponent)
    },
    {
        path: 'admin-view',
        title: 'Admin Page',
        icon: "admin.png",
        isNav: true,
        canActivate: [CalGuardService],
        roles: ["Supplier Spend Visibility - Admin"],
        loadComponent: () => import('src/components/admin/admin.component').then(m => m.AdminComponent)
    },
    {
        path: '**',
        redirectTo: 'notfound',
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ]
})

export class AppRouting { }